import classNames from 'classnames/bind';
import { isMobile } from 'react-device-detect';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import Awards from '../Awards';
import Loading from '../Loading';
import styles from './PaymentMethod.module.scss';
import { dispatchPostError } from '~/redux/reducer/error';
import { logoutAccountSuccess } from '~/redux/reducer/auth';
import { requestPlayerGetChannels } from '~/services/payment';
import { actionSelectPayment } from '~/redux/reducer/payment';

const cx = classNames.bind(styles);

function PaymentMethod() {
    const [awards, setAwards] = useState([]);
    const [members, setMembers] = useState([]);
    const [channels, setChannels] = useState([]);
    const [loading, setLoading] = useState(true);

    const { code } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { currentUser } = useSelector((state) => state.auth);
    const { paymentSelected } = useSelector((state) => state.payment);

    useEffect(() => {
        if (currentUser) {
            const fetch = async () => {
                setLoading(true);

                const source = isMobile ? 'mobile' : 'pc';

                const result = await requestPlayerGetChannels(source, code);

                setLoading(false);
                if (result.status === 403) {
                    dispatch(logoutAccountSuccess());
                    localStorage.removeItem('_re');
                    navigate('/');
                    window.location.reload();
                } else if (result.status === 401) {
                    dispatch(dispatchPostError(result));
                } else if (result.status === 200) {
                    setAwards(result.data.awards);
                    setMembers(result.data.members);
                    setChannels(result.data.channels);

                    dispatch(actionSelectPayment(result.data.channels[0]));
                } else {
                    navigate('/app');
                }
            };
            fetch();
        } else {
            navigate('/app');
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code]);

    const handleSelectPaymentMethod = (channel) => {
        if (channel.active) {
            dispatch(actionSelectPayment(channel));
        }
    };

    return (
        <Fragment>
            {loading ? (
                <Loading height="50" />
            ) : (
                <Fragment>
                    {!isMobile ? (
                        <div className={cx('wrapper')}>
                            <div className={cx('list')}>
                                {channels.map((channel, index) => (
                                    <div className={cx('item')} key={index} onClick={() => handleSelectPaymentMethod(channel)}>
                                        <div
                                            className={cx('card', {
                                                active: paymentSelected?.code === channel.code,
                                                disable: !channel.active,
                                            })}
                                        >
                                            <div className={cx('image')}>
                                                <img src={channel.image_url} alt={channel.title} />
                                            </div>

                                            {paymentSelected?.code === channel.code && (
                                                <div className={cx('arrow')}>
                                                    <div className={cx('icon')}></div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <Awards data={awards} members={members} />
                        </div>
                    ) : (
                        <div className={cx('mobile')}>
                            <ul className={cx('mobile-list')}>
                                {channels.map((channel, index) => (
                                    <li
                                        className={channel.active ? cx('mobile-item') : cx('mobile-item', 'mobile-disabled')}
                                        key={index}
                                        onClick={() => handleSelectPaymentMethod(channel)}
                                    >
                                        <Link to={`/app/${currentUser.app.code}/awards`}>
                                            <div className={cx('mobile-left')}>
                                                <div className={cx('mobile-image')}>
                                                    <img src={channel.image_mobile} alt={channel.title} />
                                                </div>
                                                <div className={cx('mobile-name')}>{channel.title}</div>
                                            </div>
                                            <div className={cx('mobile-right')}>
                                                {channel.active && <div className={cx('mobile-hot')}>Hot</div>}

                                                <FontAwesomeIcon icon={faChevronRight} />
                                            </div>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </Fragment>
            )}
        </Fragment>
    );
}

export default PaymentMethod;
